import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { Scrollbars } from 'react-custom-scrollbars';
import { PAGE_SIZE, WAIT_INTERVAL, imagePlaceholder } from '../constants.js';
import { s as styles, G as GiphyEmptyState } from '../giphyEmptyState-2c71eec4.js';
import { Spinner, Image } from 'wix-rich-content-ui-components';
import { GIPHY_ITEM } from '../dataHooks.js';
import { getGiphyProxyUrl } from './getGiphyProxyUrl.js';
import PoweredByGiphy from '../icons/PoweredByGiphy.js';
import 'wix-rich-content-common';
import '../style-inject.es-746bb8ed.js';

class GiphySelector extends Component {
  constructor(props) {
    super(props);
    this.onFetchFail = () => this.setState({ didFail: true, hasMoreItems: false, gifs: [], page: 0 });
    this.getGifs = async (searchTag, page) => {
      if (searchTag) {
        return this.getSearchGifs(searchTag, page != null ? page : 0);
      }
      this.getTrendingGifs();
    };
    this.getSearchGifs = async (searchTag, page) => {
      const url = getGiphyProxyUrl("search", this.props.getGiphyUrl);
      if (!url) {
        return this.onFetchFail();
      }
      const giphyUrl = new URL(url);
      giphyUrl.searchParams.append("q", searchTag);
      giphyUrl.searchParams.append("limit", PAGE_SIZE.toString());
      giphyUrl.searchParams.append("offset", (page * PAGE_SIZE).toString());
      const result = await fetch(giphyUrl).then(
        async (r) => r.status === 200 ? { type: "OK", data: await r.json() } : Promise.reject()
      ).catch(() => ({ type: "ERROR" }));
      if (result.type === "ERROR") {
        return this.onFetchFail();
      }
      const gifsInfo = result.data;
      const gifs = page ? [...this.state.gifs, ...gifsInfo.data] : gifsInfo.data;
      this.setState({
        gifs,
        hasMoreItems: gifs.length < gifsInfo.pagination.total_count,
        page: this.state.page + 1,
        didFail: false
      });
    };
    this.getTrendingGifs = async () => {
      const url = getGiphyProxyUrl("trending", this.props.getGiphyUrl);
      if (!url) {
        return this.onFetchFail();
      }
      const giphyUrl = new URL(url);
      giphyUrl.searchParams.append("limit", "100");
      const result = await fetch(giphyUrl).then(
        async (r) => r.status === 200 ? { type: "OK", data: await r.json() } : Promise.reject()
      ).catch(() => ({ type: "ERROR" }));
      if (result.type === "ERROR") {
        return this.onFetchFail();
      }
      const gifsInfo = result.data;
      this.setState({
        gifs: gifsInfo.data,
        hasMoreItems: false,
        page: 0,
        didFail: false
      });
    };
    this.getMoreGifs = async () => this.getGifs(this.props.searchTag, this.state.page);
    this.getBoundOnClick = (giphy) => {
      const componentData = this.convertGiphyToComponentData(giphy);
      return () => this.selectGif(componentData);
    };
    this.getBoundKeyDown = (giphy) => {
      const componentData = this.convertGiphyToComponentData(giphy);
      return (e) => {
        const { onCloseRequested } = this.props;
        if (e.key === "Escape") {
          onCloseRequested == null ? void 0 : onCloseRequested();
        }
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.selectGif(componentData);
        }
      };
    };
    const { componentData } = this.props;
    this.state = {
      url: componentData.src || "",
      isLoaded: false,
      hasMoreItems: true,
      gifs: [],
      page: 0,
      didFail: false
    };
  }
  selectGif(gif) {
    const { onGifAdd, onCloseRequested } = this.props;
    onGifAdd(gif);
    onCloseRequested();
  }
  convertGiphyToComponentData(giphy) {
    var _a;
    return {
      originalUrl: giphy.images.original.url,
      originalMp4: giphy.images.original.mp4,
      stillUrl: giphy.images.original_still.url,
      downsizedUrl: (_a = giphy.images.downsized) == null ? void 0 : _a.url,
      downsizedStillUrl: giphy.images.downsized_still.url,
      downsizedSmallMp4: giphy.images.downsized_small.mp4,
      height: giphy.images.original.height,
      width: giphy.images.original.width
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => this.getGifs(nextProps.searchTag), WAIT_INTERVAL);
  }
  componentDidMount() {
    this.timer = null;
  }
  render() {
    const { t, searchTag } = this.props;
    const { gifs, hasMoreItems, didFail } = this.state;
    const loader = /* @__PURE__ */ React.createElement("div", { className: styles[`giphy_selector_spinner_${gifs.length ? "more" : "empty_modal"}`] }, /* @__PURE__ */ React.createElement(Spinner, null));
    if (didFail) {
      return /* @__PURE__ */ React.createElement("div", { "data-hook": "giphySelector" }, /* @__PURE__ */ React.createElement("div", { className: styles.giphySelectorErrorContainer }, /* @__PURE__ */ React.createElement("div", { className: styles.giphySelectorErrorMessage }, t("GiphyPlugin_ApiErrorMsg"))), /* @__PURE__ */ React.createElement("div", { className: styles.giphy_selector_container }, /* @__PURE__ */ React.createElement(PoweredByGiphy, { className: styles.giphy_selector_powerdByGiphy })));
    }
    return /* @__PURE__ */ React.createElement("div", { "data-hook": "giphySelector" }, /* @__PURE__ */ React.createElement("div", { className: styles.giphy_selector_infinite_scroll_container }, !gifs.length && searchTag && !didFail ? /* @__PURE__ */ React.createElement(GiphyEmptyState, { t }) : /* @__PURE__ */ React.createElement(
      Scrollbars,
      {
        renderThumbVertical: () => /* @__PURE__ */ React.createElement("div", { className: styles.giphy_selector_scrollbarThumb }),
        className: styles.giphy_selector_customize_scrollbar_container
      },
      /* @__PURE__ */ React.createElement(
        InfiniteScroll,
        {
          pageStart: 0,
          loadMore: this.getMoreGifs.bind(this),
          hasMore: hasMoreItems,
          loader: !this.state.didFail ? loader : null,
          useWindow: false,
          className: styles.giphy_selector_infinite_scroll
        },
        gifs.map((giphy) => {
          const parentId = `${giphy.id}-parent`;
          return /* @__PURE__ */ React.createElement(
            "div",
            {
              key: parentId,
              role: "button",
              tabIndex: 0,
              onKeyDown: this.getBoundKeyDown(giphy),
              onClick: this.getBoundOnClick(giphy),
              "data-hook": GIPHY_ITEM
            },
            /* @__PURE__ */ React.createElement(
              Image,
              {
                id: giphy.id.toString(),
                containerId: parentId,
                role: "img",
                "aria-label": "gif",
                height: giphy.images.fixed_width_downsampled.height,
                width: giphy.images.fixed_width_downsampled.height,
                displayMode: "fill",
                containerProps: {
                  containerId: parentId,
                  className: styles.giphy_selector_gif_img_container
                },
                uri: giphy.images.fixed_width_downsampled.webp || giphy.images.fixed_width_downsampled.url,
                alt: giphy.alt_text || "gif",
                getPlaceholder: () => ({
                  uri: imagePlaceholder,
                  css: { img: {}, container: {} },
                  attr: { img: {}, container: {} }
                })
              }
            )
          );
        })
      )
    )), /* @__PURE__ */ React.createElement("div", { className: styles.giphy_selector_container }, /* @__PURE__ */ React.createElement(PoweredByGiphy, { className: styles.giphy_selector_powerdByGiphy })));
  }
}

export { GiphySelector as default };
//# sourceMappingURL=giphySelector.js.map
